const config = {
  apiKey: "AIzaSyCoVcaiIqifs2LswLCdFbLVzgxg2Ok92fs",
  authDomain: "designlabsapps.firebaseapp.com",
  databaseURL: "https://designlabsapps.firebaseio.com",
  projectId: "designlabsapps",
  storageBucket: "designlabsapps.appspot.com",
  messagingSenderId: "373533183182",
  appId: "1:373533183182:web:a685365266dfe9cd77149f",
  measurementId: "G-KZQBBZHJJW"
};

export default config;